import React, { useState } from 'react';
import { HomeIcon, CompassIcon, CalendarIcon, UsersIcon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon, SlackIcon, CalendarDaysIcon, ChevronDownIcon, ChevronUpIcon, AlarmClockCheckIcon, BotIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { PersonalizeModal } from './PersonalizeModal';
export const Sidebar = () => {
  const [expanded, setExpanded] = useState(true);
  const [personalizeModalOpen, setPersonalizeModalOpen] = useState(false);
  const [personalizationExpanded, setPersonalizationExpanded] = useState(true);
  const location = useLocation();
  const toggleSidebar = () => {
    setExpanded(!expanded);
  };
  const togglePersonalization = () => {
    setPersonalizationExpanded(!personalizationExpanded);
  };
  const handleModalClose = () => {
    setPersonalizeModalOpen(false);
  };
  const handleOptionSelect = (option: string) => {
    console.log('Selected option:', option);
    // Here you would typically save the user's preference
    setPersonalizeModalOpen(false);
  };
  // Main navigation items
  const mainNavItems = [{
    name: 'For You',
    icon: HomeIcon,
    path: '/app'
  }, {
    name: 'Discover',
    icon: CompassIcon,
    path: '/app/discover'
  }, {
    name: 'My Events',
    icon: CalendarIcon,
    path: '/app/events'
  }, {
    name: 'Friends & Circles',
    icon: UsersIcon,
    path: '/app/friends'
  }, {
    name: 'Assistant',
    icon: BotIcon,
    path: '/app/assistant'
  }];
  // Personalization section items
  const personalizationItems = [{
    name: 'My Interests',
    icon: CompassIcon,
    path: '/app/personalize'
  }, {
    name: 'My Schedule',
    icon: CalendarDaysIcon,
    path: '/app/schedule'
  }, {
    name: 'My Notifications',
    icon: AlarmClockCheckIcon,
    path: '/app/notifications'
  }];
  // Settings and other items
  const otherNavItems = [
    // {
    //   name: 'Settings',
    //   icon: SettingsIcon,
    //   path: '/app/settings',
    // },
  ];
  return <div className={`h-screen bg-gradient-to-b from-[#1A1A1D] to-[#22252A] flex flex-col transition-all duration-300 ease-in-out ${expanded ? 'w-64' : 'w-20'}`} data-id="element-142">
      <div className="p-4 flex items-center justify-between border-b border-gray-700" data-id="element-143">
        <div className={`flex items-center ${expanded ? '' : 'justify-center w-full'}`} data-id="element-144">
          <div className="w-10 h-10 bg-gradient-to-r from-sky-500 to-blue-600 rounded-lg flex items-center justify-center text-white font-bold" data-id="element-145">
            L
          </div>
          {expanded && <span className="ml-3 text-[#F5F5F7] font-bold" data-id="element-146">LaVee.life</span>}
        </div>
        <button onClick={toggleSidebar} className={`text-[#F5F5F7] hover:bg-[#2C2F33] rounded-lg p-1 ${expanded ? '' : 'hidden'}`} data-id="element-147">
          <ChevronLeftIcon size={20} data-id="element-148" />
        </button>
        <button onClick={toggleSidebar} className={`text-[#F5F5F7] hover:bg-[#2C2F33] rounded-lg p-1 absolute -right-4 top-6 bg-[#22252A] border border-gray-700 ${expanded ? 'hidden' : ''}`} data-id="element-149">
          <ChevronRightIcon size={20} data-id="element-150" />
        </button>
      </div>
      <div className="flex-1 py-6 overflow-y-auto" data-id="element-151">
        <ul className="space-y-2" data-id="element-152">
          {/* Main navigation items */}
          {mainNavItems.map(item => {
          const isActive = location.pathname === item.path;
          return <li key={item.name} data-id="element-153">
                <Link to={item.path} className={`flex items-center px-4 py-3 ${expanded ? '' : 'justify-center'} ${isActive ? 'bg-[#007BFF] text-white' : 'text-[#F5F5F7] hover:bg-[#2C2F33]'} rounded-lg mx-2 transition-colors`} data-id="element-154">
                  <item.icon size={20} data-id="element-155" />
                  {expanded && <span className="ml-3" data-id="element-156">{item.name}</span>}
                </Link>
              </li>;
        })}
          {/* Personalization section with collapsible items */}
          {expanded && <li className="mt-4" data-id="element-157">
              <button onClick={togglePersonalization} className="flex items-center justify-between w-full px-4 py-2 text-[#F5F5F7] hover:bg-[#2C2F33] rounded-lg mx-2 transition-colors" data-id="element-158">
                <span className="font-medium text-gray-400" data-id="element-159">
                  Personalization
                </span>
                {personalizationExpanded ? <ChevronUpIcon size={16} data-id="element-160" /> : <ChevronDownIcon size={16} data-id="element-161" />}
              </button>
            </li>}
          {/* Personalization items */}
          {expanded && personalizationExpanded && <div className="pl-2" data-id="element-162">
              {personalizationItems.map(item => {
            const isActive = location.pathname === item.path;
            return <li key={item.name} data-id="element-163">
                    <Link to={item.path} className={`flex items-center px-4 py-3 ${isActive ? 'bg-[#007BFF] text-white' : 'text-[#F5F5F7] hover:bg-[#2C2F33]'} rounded-lg mx-2 transition-colors ${item.isSpecial ? 'mt-1' : ''}`} data-id="element-164">
                      <item.icon size={20} data-id="element-165" />
                      <span className="ml-3" data-id="element-166">{item.name}</span>
                    </Link>
                  </li>;
          })}
            </div>}
          {/* If sidebar is collapsed, show personalization items without grouping */}
          {!expanded && personalizationItems.map(item => {
          const isActive = location.pathname === item.path;
          return <li key={item.name} data-id="element-167">
                  <Link to={item.path} className={`flex items-center justify-center px-4 py-3 ${isActive ? 'bg-[#007BFF] text-white' : 'text-[#F5F5F7] hover:bg-[#2C2F33]'} rounded-lg mx-2 transition-colors`} data-id="element-168">
                    <item.icon size={20} data-id="element-169" />
                  </Link>
                </li>;
        })}
          {/* Other navigation items */}
          {otherNavItems.map(item => {
          const isActive = location.pathname === item.path;
          return <li key={item.name} data-id="element-170">
                <Link to={item.path} className={`flex items-center px-4 py-3 ${expanded ? '' : 'justify-center'} ${isActive ? 'bg-[#007BFF] text-white' : 'text-[#F5F5F7] hover:bg-[#2C2F33]'} rounded-lg mx-2 transition-colors`} data-id="element-171">
                  <item.icon size={20} data-id="element-172" />
                  {expanded && <span className="ml-3" data-id="element-173">{item.name}</span>}
                </Link>
              </li>;
        })}
        </ul>
      </div>
      <PersonalizeModal isOpen={personalizeModalOpen} onClose={handleModalClose} onOptionSelect={handleOptionSelect} data-id="element-174" />
    </div>;
};